.flare-project-row {
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  position: relative;
}

.flare-project-row-icon {
  align-items: center;
  color: var(--flare-text-secondary, #475569);
  display: inline-flex;
  font-size: 16px;
  justify-content: center;
}

.flare-project-row-title.ant-typography {
  color: var(--flare-text-primary, #0f172a);
  display: block;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flare-project-row-meta.ant-typography {
  color: var(--flare-text-secondary, #475569);
  display: block;
  font-size: 11px;
  line-height: 1.45;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flare-project-row-copy.ant-space {
  min-width: 0;
  overflow: hidden;
  width: 100%;
}

.flare-project-row-copy > .ant-space-item {
  min-width: 0;
  overflow: hidden;
}

.flare-project-row.is-active {
  background: color-mix(in srgb, var(--flare-accent, #2b6cf3) 6%, transparent);
}

.flare-project-row.is-pinned {
  background: color-mix(in srgb, var(--flare-accent, #2b6cf3) 3%, transparent);
}

.flare-project-row.is-active.is-pinned {
  background: color-mix(in srgb, var(--flare-accent, #2b6cf3) 6%, transparent);
}

.flare-project-session-rail {
  border-left: 1px solid var(--flare-scrollbar-thumb, #dce6f3);
}

.flare-session-item {
  position: relative;
}

.flare-session-item.is-nested {
  padding-left: 8px !important;
}

.flare-session-item.is-active::before {
  background: var(--flare-accent, #2b6cf3);
  border-radius: 999px;
  content: "";
  height: 14px;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
}

.flare-session-item-title.ant-typography {
  color: var(--flare-text-primary, #0f172a);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.45;
  min-width: 0;
}

.flare-session-item.is-active .flare-session-item-title.ant-typography {
  color: var(--flare-text-primary, #0f172a);
  font-weight: 500;
}

.flare-session-item-meta.ant-typography {
  color: var(--flare-text-secondary, #475569);
  font-size: 11px;
  line-height: 1.45;
}

.flare-session-run-indicator {
  background: transparent;
  border: 0;
  color: var(--flare-accent, #2b6cf3);
  font-size: 12px;
  height: auto;
  width: auto;
}

.flare-sidebar-action-popover {
  color: var(--flare-text-primary, #0f172a);
  font-family: var(--flare-font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", sans-serif);
  font-size: 12px;
}

.flare-sidebar-action-popover-panel {
  font-family: inherit;
}

.flare-sidebar-action-popover .ant-popover-inner {
  background: var(--flare-sidebar-action-popover-bg, #ffffff);
  border: 1px solid var(--flare-sidebar-action-popover-border, #dce6f3);
  border-radius: 14px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.12);
  padding: 12px;
}

.flare-sidebar-action-popover .ant-popover-inner-content {
  padding: 0;
}

.flare-sidebar-action-popover.flare-project-row-actions-popover .ant-popover-inner {
  border-radius: 10px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.1);
  padding: 4px;
  width: 168px;
}

.flare-project-row-actions.ant-space {
  display: flex;
  width: 100%;
}

.flare-project-row-actions-popover .ant-btn {
  border-radius: 7px;
  font-size: 12px;
  font-weight: 500;
  height: 30px;
  justify-content: flex-start;
  padding-inline: 6px;
}

.flare-project-row-actions-popover .ant-btn .anticon {
  font-size: 15px;
}

.flare-project-row-actions-divider {
  background: var(--flare-sidebar-action-popover-border, #dce6f3);
  height: 1px;
  margin: 3px 5px;
}

.flare-sidebar-action-popover .ant-popover-arrow::before,
.flare-sidebar-action-popover .ant-popover-arrow::after {
  background: var(--flare-sidebar-action-popover-bg, #ffffff);
}

.flare-sidebar-action-popover .ant-typography,
.flare-sidebar-action-popover .ant-input,
.flare-sidebar-action-popover .ant-input-affix-wrapper,
.flare-sidebar-action-popover .ant-btn {
  font-family: inherit;
}

.flare-sidebar-action-popover .ant-input,
.flare-sidebar-action-popover .ant-input-affix-wrapper {
  background: var(--flare-sidebar-action-popover-input-bg, #ffffff);
  border-color: var(--flare-sidebar-action-popover-border, #dce6f3);
  border-radius: 10px;
  color: var(--flare-text-primary, #0f172a);
  font-size: 13px;
  min-height: 32px;
}

.flare-sidebar-action-popover .ant-input:focus,
.flare-sidebar-action-popover .ant-input-focused,
.flare-sidebar-action-popover .ant-input-affix-wrapper:focus,
.flare-sidebar-action-popover .ant-input-affix-wrapper-focused {
  border-color: var(--flare-surface-border-active, #3b82f6);
  box-shadow: var(--flare-focus-outline, 0 0 0 3px rgba(59, 130, 246, 0.22));
}

.flare-sidebar-action-popover .ant-btn-primary {
  background: var(--flare-accent, #2b6cf3);
  border-color: var(--flare-accent, #2b6cf3);
  box-shadow: none;
  font-weight: 650;
  min-height: 32px;
}

.flare-sidebar-action-popover .flare-project-create-submit.ant-btn {
  min-width: 32px;
  padding-inline: 0;
}

.flare-sidebar-action-popover .ant-btn-primary:hover {
  background: var(--flare-accent-hover, #3b82f6);
  border-color: var(--flare-accent-hover, #3b82f6);
}
